<template>
  <v-col
    v-if="hasObject && searchFilters.dateStart && searchFilters.dateEnd && rentalPrice && !loadingObjectInfo"
    :cols="sidebar || isMobileView ? 12 : 9"
  >
    <table style="width: 100%;">

      <!-- SUMMARY PRICE -->

      <tr v-if="monthlyPrice">
        <!-- MONTH -->
        <td>
          <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
            {{ $i18n.t('monthly_price') }}
          </span>
          <span>
            <v-icon
              small
              class="ml-2"
              @click="showTotalPriceInfo = true"
            >
              mdi-information-outline
            </v-icon>
          </span>
        </td>
        <td style="text-align: right;">
          <span style="font-weight: bold; font-size: 16px;color: #219AC8; white-space: nowrap;">
            {{ monthlyPrice }} €
          </span>
        </td>
      </tr>

      <tr v-if="monthlyPrice">
        <!-- MONTH -->
        <td colspan="2">
          {{ $i18n.t('month_utilities_will_be_extra') }}
        </td>
      </tr>

      <tr v-if="monthlyPrice" class="d-none">
        <!-- MONTH -->
        <td>
          {{ $i18n.t('internet') }} ({{ $i18n.t('month').toLowerCase() }})
        </td>
        <td style="text-align: right;">
          <span style="font-size: 16px;white-space: nowrap;">
            {{ $i18n.t('internet_month_price') }} €
          </span>
        </td>
      </tr>

      <tr v-if="monthlyPrice" class="d-none">
        <!-- MONTH -->
        <td>
          {{ $i18n.t('water') }} ({{ $i18n.t('month').toLowerCase() }})
        </td>
        <td style="text-align: right;">
          <span style="font-size: 16px;white-space: nowrap;">
            {{ $i18n.t('water_month_price') }} €
          </span>
        </td>
      </tr>

      <tr v-if="useMinPeriodPrice && !monthlyPrice">
        <td>
          {{ $i18n.t('rental_price_for_min_period') }}
          ({{ priceObject.minDays }}
          {{ $i18n.t('ööd') }})
        </td>
        <td style="text-align: right;">
          {{ priceObject.bookingMinPeriodPrice }}€
        </td>
      </tr>
      <tr v-else-if="!monthlyPrice">
        <td>
          <div style="float: left">
            {{ $i18n.t('rental_price_for') }} {{ priceObject.bookingDays }} {{ $i18n.t('ööd') }}
            <v-icon
              small
              class="ml-2"
              @click="showDayPrices = true"
            >
              mdi-information-outline
            </v-icon>
          </div>
        </td>
        <td style="text-align: right;">
          <span style="cursor:pointer;">{{ priceObject.bookingPrice }} €</span>
        </td>
      </tr>

      <!-- DAY PRICES -->

      <tr
        v-if="showDayPrices"
      >
        <td colspan="2">
          <v-container
            :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
          >
            <v-row
              class="my-0 mt-0 mb-2 align-center"
              style="padding-bottom: 5px;"
            >
              <v-col
                cols="12"
                class="text-center"
              >
                <v-btn
                  fab text dark small
                  class="form-close csr-btn-color"
                  @click="showDayPrices = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              style="max-height: 250px; background: white; overflow: auto;"
              dense
            >
              <template
                v-for="(dayPrice, index) in priceObject.dayPrices"
              >
                <v-col
                  :key="index"
                  cols="7"
                  style="border-top: 1px solid #DDD;"
                >
                  {{ dayPriceTitle(dayPrice) }}<br>
                </v-col>
                <v-col
                  :key="index + '_p'"
                  cols="5"
                  style="border-top: 1px solid #DDD;"
                >
                  {{ dayPricePrice(dayPrice) }}<br>
                </v-col>
              </template>
            </v-row>
          </v-container>
        </td>
      </tr>

      <!-- CLEANING FEE -->

      <tr>
        <td>{{ $i18n.t('cleaning') }}</td>
        <td style="text-align: right;">{{ priceObject.cleaningFee || cleaningFee }} €</td>
      </tr>

      <!-- CSR FEE -->

      <tr>
        <td>{{ $i18n.t('csr_fee') }}</td>
        <td style="text-align: right;">{{ computedCsrFee }} €</td>
      </tr>

      <!-- LATE CHECK-IN FEE -->

      <tr v-if="lateCheckInFee">
        <td>{{ $i18n.t('late_checkin_fee') }}</td>
        <td style="text-align: right;">{{ lateCheckInFee }} €</td>
      </tr>

      <!-- EXTRAS PRICE -->

      <tr>
        <td>{{ $i18n.t('booking_extras') }}</td>
        <td style="text-align: right;">{{ bookingExtrasPrice }} €</td>
      </tr>

      <!-- SUMMARY PRICE  // SHOR TERM -->

      <tr v-if="monthlyPrice && priceObject.bookingDays < 61">

        <!-- TOTAL PRICE -->

        <td>
          <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
            {{ $i18n.t('total_price') }}
          </span>
          ({{ priceObject.bookingDays }}
          {{ $i18n.t('ööd') }})
        </td>
        <td style="text-align: right; white-space: nowrap;">
          <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
            {{ finalPrice }} €
          </span>
        </td>
      </tr>

      <!-- SUMMARY PRICE -->
      <tr v-if="!monthlyPrice">

        <!-- TOTAL PRICE -->

        <td>
          <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
            {{ $i18n.t('total_price') }}
          </span>
          <span>
            <v-icon
              small
              class="ml-2"
              @click="showTotalPriceInfo = true"
            >
              mdi-information-outline
            </v-icon>
          </span>
        </td>
        <td style="text-align: right; white-space: nowrap;">
          <span style="font-weight: bold; font-size: 16px;color: #219AC8;">
            {{ finalPrice }} €
          </span>
        </td>
      </tr>

      <!-- TOTAL PRICE INFO BOX -->

      <tr
        v-if="showTotalPriceInfo"
      >
        <td colspan="2">
          <v-container
            :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
            style="margin-top: 10px;"
          >
            <v-row
              class="my-0 mt-0 mb-2 align-center"
              style="padding-bottom: 0; width: 100%;"
            >
              <v-col
                cols="12"
                class="text-center"
              >
                <v-btn
                  fab text dark small
                  class="form-close csr-btn-color"
                  @click="showTotalPriceInfo = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <template
                  v-if="priceObject && priceObject.bookingDays >= 26"
                >
                  <div v-html="$i18n.t('long_period_rent_info')"/>
                </template>
                <template v-else>
                  {{ $i18n.t('price_includes_taxes') }}
                </template>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </tr>

      <!-- RESERVATION FEE -->

      <tr>
        <td>
          {{ $i18n.t('reservation_fee') }}
          <v-icon
            small
            class="ml-2"
            @click="showReservationInfo = true"
          >
            mdi-information-outline
          </v-icon>
        </td>
        <td style="text-align: right;">{{ reservationFee }} €</td>
      </tr>

      <!-- RESERVATION FEE INFO BOX -->

      <tr
        v-if="showReservationInfo"
      >
        <td colspan="2">
          <v-container
            :class="(sidebar ? 'popup-select-container-sidebar' : 'popup-select-container') + ' elevation-5 '"
          >
            <v-row
              class="my-0 mt-0 mb-2 align-center"
            >
              <v-col
                cols="12"
                class="text-center"
              >
                <v-btn
                  fab text dark small
                  class="form-close csr-btn-color"
                  @click="showReservationInfo = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                {{ $i18n.t('reservation_fee_info') }}
              </v-col>
            </v-row>
          </v-container>
        </td>
      </tr>
    </table>
  </v-col>
</template>

<script>
import sharedObjectComputed from '@/methods/sharedObjectComputed'
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import moment from 'moment'
import sharedComputed from '@/methods/sharedComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'BookingPriceTable',

  data: () => {
    return {
      showReservationInfo: false,
      showDayPrices: false,
      showTotalPriceInfo: false,
    }
  },

  props: {
    hasObject: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: () => {},
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
    computedMobile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...sharedObjectComputed,
  },

  methods: {
    dayPriceTitle (price) {
      return moment(price.day).format('DD.MM.YYYY')
    },

    dayPricePrice (price) {
      return price.price + ' €'
    },
  },
}
</script>
